/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TranslationSearchOrderBy } from './TranslationSearchOrderBy';
import {
    TranslationSearchOrderByFromJSON,
    TranslationSearchOrderByFromJSONTyped,
    TranslationSearchOrderByToJSON,
    TranslationSearchOrderByToJSONTyped,
} from './TranslationSearchOrderBy';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';

/**
 * 
 * @export
 * @interface TranslationSearchOrderByPaginationQuery
 */
export interface TranslationSearchOrderByPaginationQuery {
    /**
     * 
     * @type {any}
     * @memberof TranslationSearchOrderByPaginationQuery
     */
    pageNumber?: any | null;
    /**
     * 
     * @type {any}
     * @memberof TranslationSearchOrderByPaginationQuery
     */
    pageSize?: any | null;
    /**
     * 
     * @type {SortOrder}
     * @memberof TranslationSearchOrderByPaginationQuery
     */
    sortOrder?: SortOrder;
    /**
     * 
     * @type {TranslationSearchOrderBy}
     * @memberof TranslationSearchOrderByPaginationQuery
     */
    orderField?: TranslationSearchOrderBy;
}



/**
 * Check if a given object implements the TranslationSearchOrderByPaginationQuery interface.
 */
export function instanceOfTranslationSearchOrderByPaginationQuery(value: object): value is TranslationSearchOrderByPaginationQuery {
    return true;
}

export function TranslationSearchOrderByPaginationQueryFromJSON(json: any): TranslationSearchOrderByPaginationQuery {
    return TranslationSearchOrderByPaginationQueryFromJSONTyped(json, false);
}

export function TranslationSearchOrderByPaginationQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationSearchOrderByPaginationQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'pageNumber': json['pageNumber'] === undefined ? undefined : json['pageNumber'] === null ? null : json['pageNumber'],
        'pageSize': json['pageSize'] === undefined ? undefined : json['pageSize'] === null ? null : json['pageSize'],
        'sortOrder': json['sortOrder'] == null ? undefined : SortOrderFromJSON(json['sortOrder']),
        'orderField': json['orderField'] == null ? undefined : TranslationSearchOrderByFromJSON(json['orderField']),
    };
}

export function TranslationSearchOrderByPaginationQueryToJSON(json: any): TranslationSearchOrderByPaginationQuery {
    return TranslationSearchOrderByPaginationQueryToJSONTyped(json, false);
}

export function TranslationSearchOrderByPaginationQueryToJSONTyped(value?: TranslationSearchOrderByPaginationQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
        'sortOrder': SortOrderToJSON(value['sortOrder']),
        'orderField': TranslationSearchOrderByToJSON(value['orderField']),
    };
}

